import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DashboardPin } from '../../../models/dashboard-pin.model';
import { DashboardPinService } from '../../../services/dashboard-pin.service';
import { FreigabeKachelComponent } from './freigabe-kachel.component';

@Component({
  selector: 'app-freigabe-status',
  imports: [TranslatePipe, FreigabeKachelComponent],
  templateUrl: './freigabe-status.component.html',
  styleUrl: './freigabe-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreigabeStatusComponent implements OnInit {
  private pinService = inject(DashboardPinService);
  private snackBar = inject(MatSnackBar);
  private translate = inject(TranslateService);
  private destroyRef = inject(DestroyRef);

  protected readonly pins = signal<DashboardPin[]>([]);
  protected readonly showProject = computed(() => new Set(this.pins().map((p) => p.projectId)).size > 1);

  ngOnInit(): void {
    this.pinService
      .list()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (pins) => this.pins.set(pins),
        error: () => this.pins.set([]),
      });
  }

  protected onRemove(pin: DashboardPin): void {
    this.pinService
      .remove(pin.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.pins.update((pins) => pins.filter((p) => p.id !== pin.id)),
        error: () =>
          this.snackBar.open(this.translate.instant('liveDashboard.freigabeStatus.removeError'), undefined, {
            panelClass: 'snackbar-error',
          }),
      });
  }
}
